import { render, staticRenderFns } from "./LoanComponent.vue?vue&type=template&id=ecc94212&scoped=true"
import script from "./LoanComponent.vue?vue&type=script&lang=js"
export * from "./LoanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc94212",
  null
  
)

export default component.exports